// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table, Button, Input } from 'semantic-ui-react';
import _ from 'lodash';
// local
// views
import Page from 'app/ui/pages/Page';
import SupplierModal from 'app/ui/modal/SupplierModal';
import EmptyList from 'app/ui/commons/emptyList/EmptyList';
// consts
import { TYPE as CLIENT_TYPE } from 'salvus-shared/consts/client';
import { PROFILE as ACCOUNT_PROFILE } from 'salvus-shared/consts/account';
// actions
import { openSave, openUpdate, TYPE } from 'app/redux/actions/modal';
import { list, search, reset } from 'app/redux/actions/supplier';
// libs
import { formatNumber } from 'app/lib/helper';

class Suppliers extends Component {
    constructor(props) {
        super(props);
        this.callSearch = _.debounce(this.callSearch, 100);
        this.state = {
            search: props.supplier.filter.term,
        };
    }

    // Handler for the change in the input
    onSearchChange = (e, { value }) => {
        this.setState({ search: value });
        this.callSearch(value);
    };

    callSearch = value => this.props.dispatch(search(value));

    componentDidMount = () => this.props.dispatch(list());

    componentWillUnmount = () => this.props.dispatch(reset());

    onClickAdd = () => this.props.dispatch(openSave(TYPE.SUPPLIER));

    onClickEdit = supplier => () => this.props.dispatch(openUpdate(TYPE.SUPPLIER, supplier));

    renderEmpty = () => <EmptyList emptyMessage="Nenhum fornecedor encontrado." />;

    renderTable(data) {
        const { auth } = this.props;
        return (
            <Table id="list-suppliers">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell width={1}>Código</Table.HeaderCell>
                        <Table.HeaderCell>Nome</Table.HeaderCell>
                        <Table.HeaderCell>CNPJ</Table.HeaderCell>
                        <Table.HeaderCell>E-mail</Table.HeaderCell>
                        <Table.HeaderCell>Telefone 1</Table.HeaderCell>
                        <Table.HeaderCell>Telefone 2</Table.HeaderCell>
                        <Table.HeaderCell>Preço m³</Table.HeaderCell>
                        {auth.account.client.type === CLIENT_TYPE.SALVUS && <Table.HeaderCell>Cliente</Table.HeaderCell>}
                        <Table.HeaderCell />
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {_.map(data, row => {
                        const { id, name, cnpj, email, phone1, phone2, price, clientId, client } = row;
                        const clientName = clientId ? client.name : '-';
                        let emails = email;
                        if (typeof emails === 'string') {
                            try {
                                emails = JSON.parse(emails);
                            } catch (e) {
                                emails = email;
                            }
                        }
                        return (
                            <Table.Row key={id}>
                                <Table.Cell width="1">{id}</Table.Cell>
                                <Table.Cell width="3" className="wrap">
                                    {name}
                                </Table.Cell>
                                <Table.Cell width="2">{cnpj}</Table.Cell>
                                <Table.Cell width="2" className="wrap">
                                    {!_.isArray(emails) ? (
                                        emails
                                    ) : (
                                        <div>
                                            {_.map(emails, (email, index) => {
                                                return <div key={index}>{email}</div>;
                                            })}
                                        </div>
                                    )}
                                </Table.Cell>
                                <Table.Cell width="2">{phone1}</Table.Cell>
                                <Table.Cell width="2">{phone2}</Table.Cell>
                                <Table.Cell width="1">R$ {formatNumber(price)}</Table.Cell>
                                {client && auth.account.client.type === CLIENT_TYPE.SALVUS && (
                                    <Table.Cell width="2" className="wrap">
                                        {clientName}
                                    </Table.Cell>
                                )}
                                <Table.Cell textAlign="right" width="1">
                                    {!(auth.account.client.type === CLIENT_TYPE.SALVUS && auth.account.profile === ACCOUNT_PROFILE.DEFAULT) && (
                                        <Button circular icon="edit" onClick={this.onClickEdit(row)} />
                                    )}
                                </Table.Cell>
                            </Table.Row>
                        );
                    })}
                </Table.Body>
            </Table>
        );
    }
    render() {
        const { auth, supplier } = this.props;
        const { filter, loading } = supplier;
        return (
            <Page id="page-supplier" loading={loading}>
                <div className="page-header">
                    <div className="page-title">FORNECEDORES</div>
                    {!(auth.account.client.type === CLIENT_TYPE.SALVUS && auth.account.profile === ACCOUNT_PROFILE.DEFAULT) && (
                        <div className="flex-right">
                            <Button content="Adicionar" onClick={this.onClickAdd} />
                        </div>
                    )}
                </div>
                <div className="body">
                    <div className="body-header">
                        <Input id="supplier-search" placeholder="Pesquisar..." className="search" onChange={this.onSearchChange} value={this.state.search} />
                    </div>
                    {_.isEmpty(filter.data) ? this.renderEmpty() : this.renderTable(filter.data)}
                </div>
                <SupplierModal />
            </Page>
        );
    }
}

Suppliers.propTypes = {
    supplier: PropTypes.object,
    dispatch: PropTypes.func,
    auth: PropTypes.object,
};

const mapStateToProps = state => ({
    supplier: state.supplier,
    auth: state.auth,
});
export default connect(mapStateToProps)(Suppliers);
